import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { initialize, reduxForm, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import M from 'materialize-css';

import FormButton from '../../../components/UI/FormButton';
import DatePicker from '../../../components/UI/DatePicker';
import { 
    renderFieldTwoColumns,
    renderSelectFieldTwoColumns 
} from '../../../components/UI/Fileds';

import { 
    fetchDiplomaTipoList
} from '../../../actions/ui';

import { dateToDatepicker } from '../../../helpers/converter';

import { setStudentDiplomaFilter } from '../../../actions/studentDiploma';

const StudentDiplomaSearchForm = ({ submitting, handleSubmit }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { filter } = useSelector(state => state.studentDiploma);

    const { diplomaTipoList } = useSelector(state => state.ui);

    useEffect(() => {
        const collapsibles = document.querySelectorAll('.collapsible');
        M.Collapsible.init(collapsibles, {});

        dispatch(fetchDiplomaTipoList()).then((res) => {
            if (res.ok) {
                const selects = document.querySelectorAll('select');
                M.FormSelect.init(selects, {});
            }
        });
        
        dispatch(initialize('studentDiplomaSearchForm', {
            ...filter,
            datepicker_fecha: dateToDatepicker(filter.fecha)
        }));

    }, [dispatch, filter]);
    
    const handleReset = () => {
        dispatch(setStudentDiplomaFilter({}));
    };

    const handleSearch = (values) => {
        const collapsibles = document.getElementsByClassName('collapsible-search-form');
        const instance = M.Collapsible.getInstance(collapsibles[0]);
        instance.close();

        dispatch(setStudentDiplomaFilter({
            ciudad: values.ciudad,
            diplomas_tipo_id: values.diplomas_tipo_id,
            nombre: values.nombre,
            apellidos: values.apellidos,
            fecha: values.fecha
        }));
    }

    const renderForm = () => {
        return (
            <form className="search-form" onSubmit={ handleSubmit(handleSearch) }>
                <div className="row margin">
                    <Field type="text" name="ciudad" id="ciudad" 
                        label={ t('screens-diploma-list-ciudad') } 
                        component={ renderFieldTwoColumns } 
                        icon="business" 
                        key="ciudad" 
                    />
                    <Field name="diplomas_tipo_id" id="diplomas_tipo_id" 
                        label={ t('screens-diploma-list-tipo') } 
                        component={ renderSelectFieldTwoColumns } 
                        icon="bookmark" 
                        key="diplomas_tipo_id" 
                    >
                        <option value="">{ t('form-select-choose-one') }</option>
                        {
                            diplomaTipoList.map(tipo => (
                                <option value={ tipo.id } key={ tipo.id }>{ tipo.nombre }</option>
                            ))
                        }
                    </Field>
                </div>

                <div className="row margin">
                    <Field type="text" name="nombre" id="nombre" 
                        label={ t('screens-student-diploma-list-nombre') } 
                        component={ renderFieldTwoColumns } 
                        icon="person_outline" 
                        key="nombre" 
                    />
                    <Field type="text" name="apellidos" id="apellidos" 
                        label={ t('screens-student-diploma-list-apellidos') } 
                        component={ renderFieldTwoColumns } 
                        icon="person" 
                        key="apellidos" 
                    />
                </div>

                <div className="row margin">
                    <DatePicker form="studentDiplomaSearchForm" name="fecha" 
                        value={''}
                        label={ t('screens-diploma-list-fecha') }
                        render={ renderFieldTwoColumns }
                    />
                </div>

                <div className="row">
                    <div className="input-field col s12">
                        <FormButton type="submit"
                            title={ t('search-form-button-title') }
                            disabled={ submitting }
                        />

                        <FormButton type="reset"
                            title={ t('reset-form-button-title') }
                            disabled={ submitting }
                            onClick={ handleReset }
                        />
                    </div>
                </div>

            </form>
        );
    };

    return (
        <ul className="collapsible popout collapsible-search-form">
            <li>
                <div className="collapsible-header">
                    <i className="material-icons">tune</i> { t('filter-title') }
                </div>
                <div className="collapsible-body">
                    { renderForm() }
                </div>
            </li>
            
        </ul>
    );
};

const validate = (values) => ({});

export default reduxForm({
    form: 'studentDiplomaSearchForm',
    validate: validate,
    destroyOnUnmount: false
})(StudentDiplomaSearchForm);